// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute, redirect } from "@tanstack/react-router";

// Kept for links already handed out (support tickets): image redaction now lives in the list's dialog
export const Route = createFileRoute("/_authenticated/hardware/pii-marker/images/$imageId")({
  beforeLoad: ({ params }) => {
    const imageId = /^\d+$/.test(params.imageId) ? Number(params.imageId) : undefined;
    throw redirect({ to: "/hardware/pii-marker", search: imageId ? { image: imageId } : {}, replace: true });
  },
});
